import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '@/components/base'
import { AppIcons } from '@/components/AppIcons'
import { links } from '@/constants/links'

export const KemCardDisclaimer: React.FC = () => {
  const { t } = useTranslation()

  const handleKemClick = () => {
    window.open(links.universalLinkDomain, '_blank')
  }

  const handleInterlaceClick = () => {
    window.open(links.interlaceTerms, '_blank')
  }

  const handleTermsClick = () => {
    window.open(links.termsAndConditions, '_blank')
  }

  return (
    <BaseView
      row
      align="flex-start"
      gap={8}
      py={16}
      style={{
        // backgroundColor: theme.colors.background.cardItemRoot,
        borderRadius: 12,
      }}
    >
      <BaseView pt={4}>
        <AppIcons
          name="roundedWarning"
          size={26}
          color="label.warningDescription"
        />
      </BaseView>

      <BaseView flex={1}>
        <BaseText
          fontSize={15}
          fontFamily="regular"
          color="label.warningDescription"
          lineHeight={22}
        >
          <BaseText
            fontSize={15}
            fontFamily="semibold"
            color="label.link"
            style={{
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
            onClick={handleKemClick}
          >
            Kem
          </BaseText>{' '}
          {t(
            'kemCard.aboutDescription',
            'is a financial services platform. Prepaid card services are provided by',
          )}{' '}
          <BaseText
            fontSize={15}
            fontFamily="semibold"
            color="label.link"
            style={{
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
            onClick={handleInterlaceClick}
          >
            Interlace
          </BaseText>
          . {t('translation:see', 'See')}{' '}
          <BaseText
            fontSize={15}
            fontFamily="semibold"
            color="label.link"
            style={{
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
            onClick={handleTermsClick}
          >
            {t('translation:termsAndConditions', 'terms and conditions')}.
          </BaseText>
        </BaseText>
      </BaseView>
    </BaseView>
  )
}
